import SubscriberDependentsTable from 'components/common/election/SubscriberDependentsTable';
import React from 'react';
import { observer } from 'mobx-react-lite';
import { useAddDependentModalStore } from 'store/modules/subscriber/subscriber-basic-info/dependents/addDependentModalStore';
import { DynamicFormModal } from '@insurancemenu/imenu-components-lib';
import { IFullFormPageStoreShape } from 'store/modules/full-employee-form/iFullFormPageStore';
import { ADD_DEPENDENT_MODAL_TEST_ID, DEPENDENTS_TAB_TEST_ID } from '../constants';

interface Props {
  readonly pageStore: IFullFormPageStoreShape;
}

const DependentsTab: React.FC<Props> = observer(({ pageStore }) => {
  const { dependentsTab } = pageStore;
  const formId = dependentsTab.getDependentFormId();

  const addDependentModalStore = useAddDependentModalStore({
    subscriberBasicInfo: dependentsTab.subscriberBasicInfo!,
    formId: formId!,
  });

  return (
    <div data-test-id={DEPENDENTS_TAB_TEST_ID}>
      <SubscriberDependentsTable
        isLoading={dependentsTab.isLoading}
        dependentDelegates={dependentsTab.dependentDelegates}
        subscriberBasicInfo={dependentsTab.subscriberBasicInfo ?? null}
        formId={formId!}
        onAddDependent={addDependentModalStore?.openAddDependentModal}
      />

      {addDependentModalStore && (
        <DynamicFormModal
          show={addDependentModalStore.showAddDependentModal}
          onClose={addDependentModalStore.closeAddDependentModal}
          formDelegate={addDependentModalStore.dynamicFormDelegate}
          modalMaxWidth="90rem"
          data-test-id={ADD_DEPENDENT_MODAL_TEST_ID}
          completeButtonText="Save"
        />
      )}
    </div>
  );
});

export default DependentsTab;
